'use strict'

import Api from '@/api/user.js'

const state = {
  loading: false,
  error: null,
  enabled: null,
  periods: []
}

const actions = {
  fetch ({ commit, dispatch }) {
    commit('fetching')

    return Api.fetchNotificationsPeriods()
      .then(data => commit('fetchSuccess', data))
      .catch(err => {
        dispatch('global/setError', err, {root: true})
        commit('fetchFailure', err)
      })
  },

  update ({ commit, dispatch }, { apiData, rethrowError = false }) {
    commit('updating')

    return Api.updateNotificationsPeriods(apiData)
      .then(data => {
        commit('updateSuccess', data)
      })
      .catch(err => {
        commit('updateFailure', err)

        if (rethrowError) {
          throw err
        } else {
          this.$store.dispatch('global/setError', err, { root: true })
        }
      })
  }
}

const mutations = {
  fetching (state) {
    state.loading = true
  },

  fetchSuccess (state, { enabled, periods }) {
    state.loading = false
    state.enabled = enabled
    state.periods = periods
  },

  fetchFailure (state, err) {
    state.loading = false
    state.err = err
  },

  updating (state) {
    state.loading = true
  },

  updateSuccess (state, { enabled, periods }) {
    state.loading = false
    state.enabled = enabled
    state.periods = periods
  },

  updateFailure (state, err) {
    state.loading = false
    state.err = err
  },

  updateStateEnable (state, value) {
    state.enabled = value
  },

  updateStatePeriod (state, { id, is_active }) {
    state.periods = state.periods.map(p => {
      return p.id === id
        ? Object.assign({}, p, { is_active })
        : p
    })
  }
}

const getters = {
  enabled: (state) => state.enabled,
  periods: (state) => state.periods
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
